import { Outlet } from 'react-router-dom';
import { PageHeader } from '../../components/shared/PageHeader';
import { RouteTabs } from '../../components/shared/RouteTabs';

// The /settings shell: one heading and a tab strip over three nested routes.
//
// Routed tabs rather than local state, for the reason every other tab strip in this app is routed
// — a deep link opens on the right tab and the back button behaves. Here it also means the topbar
// user menu can point straight at Security without landing on Profile first.
const TABS = [
  // `end` on the index tab: without it "/settings" stays lit while the two children are open, and
  // two tabs read as active at once.
  { to: '/settings', label: 'Profile', end: true },
  { to: '/settings/notifications', label: 'Notifications' },
  { to: '/settings/security', label: 'Security' },
];

export function SettingsLayout() {
  return (
    <div className="mx-auto w-full max-w-[720px]">
      <PageHeader title="Settings" sub="Your profile, what ProRef tells you about, and your password." />
      <RouteTabs tabs={TABS} />
      <Outlet />
    </div>
  );
}
